/* Savage Santa – theme.js (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || { root: '/', cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change' };

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = String(format || theme.moneyFormat || '€{{amount}}')
      .replace(/<[^>]*>/g, '')
      .replace(/&euro;/g, '€').replace(/&pound;/g, '£').replace(/&#36;|&dollar;/g, '$').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ')
      .trim();
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function toast(message) {
    var el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 2600);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function fetchJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Error');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer & cart page                                             */
  /* ------------------------------------------------------------------ */
  var Cart = {
    drawer: function () { return document.querySelector('[data-cart-drawer]'); },
    page: function () { return document.querySelector('[data-cart-page]'); },

    sectionsToRender: function () {
      var ids = [];
      if (this.drawer()) ids.push('cart-drawer');
      var page = this.page();
      if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
      return ids;
    },

    open: function () {
      var d = this.drawer();
      if (!d) { window.location.href = routes.cart; return; }
      this._lastFocus = document.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var panel = d.querySelector('.drawer__panel');
      if (panel) setTimeout(function () { panel.focus(); }, 50);
    },

    close: function () {
      var d = this.drawer();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this._lastFocus) this._lastFocus.focus();
    },

    render: function (sections) {
      if (!sections) return;
      var parser = new DOMParser();
      var d = this.drawer();
      if (d && sections['cart-drawer']) {
        var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('.drawer__panel');
        var panel = d.querySelector('.drawer__panel');
        if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      }
      var page = this.page();
      if (page && sections[page.dataset.sectionId]) {
        var doc2 = parser.parseFromString(sections[page.dataset.sectionId], 'text/html');
        var freshContents = doc2.querySelector('[data-cart-contents]');
        var contents = page.querySelector('[data-cart-contents]');
        if (freshContents && contents) contents.innerHTML = freshContents.innerHTML;
      }
    },

    setLoading: function (on) {
      var d = this.drawer();
      if (d) d.classList.toggle('is-loading', on);
      var p = this.page();
      if (p) p.style.opacity = on ? '.6' : '';
    },

    change: function (key, quantity) {
      var self = this;
      self.setLoading(true);
      return fetchJSON(routes.cart_change + '.js', { id: key, quantity: quantity, sections: self.sectionsToRender(), sections_url: window.location.pathname })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          self.render(cart.sections);
          // remove shipping protection if it is the only thing left
          var pid = theme.protectionProductId;
          if (pid && cart.items.length && cart.items.every(function (i) { return i.product_id === pid; })) {
            return self.change(cart.items[0].key, 0);
          }
        })
        .catch(function (e) { toast(e.message); })
        .finally(function () { self.setLoading(false); });
    },

    add: function (items) {
      var self = this;
      return fetchJSON(routes.cart_add + '.js', { items: items, sections: self.sectionsToRender(), sections_url: window.location.pathname })
        .then(function (res) {
          self.render(res.sections);
          return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return cart;
        });
    }
  };
  window.SavageCart = Cart;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && Cart.drawer() && theme.cartType === 'drawer') {
      e.preventDefault();
      Cart.open();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      Cart.close();
      return;
    }
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-line-key]');
      if (line) Cart.change(line.dataset.lineKey, parseInt(qtyBtn.dataset.cartQty, 10));
      return;
    }
    var addBtn = e.target.closest('[data-cart-add]');
    if (addBtn) {
      addBtn.disabled = true;
      Cart.add([{ id: parseInt(addBtn.dataset.cartAdd, 10), quantity: 1 }])
        .catch(function (err) { toast(err.message); addBtn.disabled = false; });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (input) {
      var line = input.closest('[data-line-key]');
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      if (line) Cart.change(line.dataset.lineKey, q);
    }
    var protect = e.target.closest('[data-protection-toggle]');
    if (protect) {
      if (protect.checked) {
        Cart.setLoading(true);
        Cart.add([{ id: parseInt(protect.dataset.variant, 10), quantity: 1 }])
          .catch(function (err) { toast(err.message); protect.checked = false; })
          .finally(function () { Cart.setLoading(false); });
      } else if (protect.dataset.key) {
        Cart.change(protect.dataset.key, 0);
      }
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetchJSON(routes.cart_update + '.js', { note: note.value }).catch(function () {});
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Cart.close();
  });

  /* ------------------------------------------------------------------ */
  /* Product                                                             */
  /* ------------------------------------------------------------------ */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = document.getElementById(root.dataset.formId) || root.querySelector('form.product-form');
    var idInput = root.querySelector('[data-variant-id]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var atc = root.querySelector('[data-atc]');
    var stickyBar = root.querySelector('[data-sticky-atc]');
    var errorBox = root.querySelector('[data-form-error]');
    var picker = root.querySelector('[data-variant-picker]');
    var breaks = root.querySelector('[data-breaks]');
    var gallery = root.querySelector('[data-gallery]');

    var currentVariant = product.variants.find(function (v) { return idInput && String(v.id) === String(idInput.value); }) || product.variants[0];
    var selectedQty = 1;

    /* --- quantity --- */
    function setQty(q) {
      selectedQty = Math.max(1, parseInt(q, 10) || 1);
      if (qtyInput) qtyInput.value = selectedQty;
    }
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(selectedQty + parseInt(btn.dataset.qtyStep, 10));
        syncBreaksToQty();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); syncBreaksToQty(); });

    /* --- quantity breaks --- */
    function syncBreaksToQty() {
      if (!breaks) return;
      breaks.querySelectorAll('[data-tier]').forEach(function (tier) {
        var on = parseInt(tier.dataset.qty, 10) === selectedQty;
        tier.classList.toggle('is-selected', on);
        tier.querySelector('input').checked = on;
      });
    }
    function updateBreakPrices() {
      if (!breaks) return;
      breaks.querySelectorAll('[data-tier]').forEach(function (tier) {
        var q = parseInt(tier.dataset.qty, 10);
        var d = parseFloat(tier.dataset.discount) || 0;
        var full = currentVariant.price * q;
        var total = Math.round(full * (1 - d / 100));
        var compareUnit = currentVariant.compare_at_price > currentVariant.price ? currentVariant.compare_at_price : currentVariant.price;
        var compare = compareUnit * q;
        var priceEl = tier.querySelector('[data-tier-price]');
        var compareEl = tier.querySelector('[data-tier-compare]');
        if (priceEl) priceEl.textContent = formatMoney(total);
        if (compareEl) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = !(compare > total);
        }
      });
    }
    if (breaks) {
      breaks.querySelectorAll('[data-tier]').forEach(function (tier) {
        tier.addEventListener('click', function () {
          setQty(tier.dataset.qty);
          syncBreaksToQty();
        });
      });
      var pre = breaks.querySelector('[data-tier].is-selected');
      if (pre) setQty(pre.dataset.qty);
    }

    /* --- variants --- */
    function selectedOptions() {
      if (!picker) return currentVariant.options.slice();
      var opts = [];
      picker.querySelectorAll('select[data-option-index]').forEach(function (sel) {
        opts[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
      });
      picker.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(function (r) {
        opts[parseInt(r.dataset.optionIndex, 10)] = r.value;
      });
      return opts;
    }

    function markAvailability(opts) {
      if (!picker) return;
      picker.querySelectorAll('input[type="radio"][data-option-index]').forEach(function (r) {
        var idx = parseInt(r.dataset.optionIndex, 10);
        var ok = product.variants.some(function (v) {
          if (!v.available || v.options[idx] !== r.value) return false;
          for (var i = 0; i < idx; i++) { if (v.options[i] !== opts[i]) return false; }
          return true;
        });
        r.classList.toggle('is-unavailable', !ok);
      });
    }

    function onVariantChange() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (picker) {
        opts.forEach(function (val, i) {
          var label = picker.querySelector('[data-option-label="' + i + '"]');
          if (label) label.textContent = val;
        });
      }
      markAvailability(opts);
      updateVariant(variant);
    }

    function updateVariant(variant) {
      var labels = root.querySelectorAll('[data-atc-label]');
      var buttons = [atc, root.querySelector('[data-sticky-btn]')].filter(Boolean);
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; });
        labels.forEach(function (l) { l.textContent = atc ? atc.dataset.textUnavailable : 'Unavailable'; });
        return;
      }
      currentVariant = variant;
      if (idInput) idInput.value = variant.id;

      // prices
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var onSale = variant.compare_at_price > variant.price;
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        el.textContent = formatMoney(variant.compare_at_price);
        el.hidden = !onSale;
      });
      var save = root.querySelector('[data-save]');
      if (save) {
        var tpl = save.dataset.saveLabel || 'SAVE [value]';
        var val = save.dataset.saveStyle === 'amount'
          ? formatMoney(variant.compare_at_price - variant.price)
          : Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        save.textContent = tpl.replace('[value]', val);
        save.hidden = !onSale;
      }
      var badge = root.querySelector('[data-gallery-badge]');
      if (badge) badge.hidden = !onSale;

      // buttons
      buttons.forEach(function (b) { b.disabled = !variant.available; });
      var addText = atc ? atc.dataset.textAdd : '';
      var soldText = atc ? atc.dataset.textSoldout : 'Sold out';
      if (atc) atc.querySelector('[data-atc-label]').textContent = variant.available ? addText : soldText;
      var stickyBtn = root.querySelector('[data-sticky-btn] [data-atc-label]');
      if (stickyBtn) {
        if (!stickyBtn.dataset.original) stickyBtn.dataset.original = stickyBtn.textContent;
        stickyBtn.textContent = variant.available ? stickyBtn.dataset.original : soldText;
      }

      // stock
      var stock = root.querySelector('[data-stock]');
      if (stock) {
        var threshold = parseInt(stock.dataset.threshold, 10) || 0;
        var low = variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold;
        stock.querySelector('[data-stock-text]').textContent = low
          ? stock.dataset.lowText.replace('[count]', variant.inventory_quantity)
          : stock.dataset.fallbackText;
        stock.classList.toggle('is-ok', !low);
      }

      updateBreakPrices();

      // media
      if (variant.featured_media && gallery) gallery._goTo(String(variant.featured_media));

      // url
      if (root.dataset.updateUrl === 'true' && document.body.classList.contains('template-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', function (e) {
        var radio = e.target.closest('input[type="radio"]');
        if (radio) {
          picker.querySelectorAll('input[name="' + radio.name + '"]').forEach(function (r) { r.checked = r === radio; });
        }
        onVariantChange();
      });
      markAvailability(selectedOptions());
    }

    /* --- submit --- */
    function submit(e) {
      if (e) e.preventDefault();
      if (!currentVariant || !currentVariant.available) return;
      if (errorBox) errorBox.hidden = true;
      var items = [{ id: currentVariant.id, quantity: selectedQty }];
      root.querySelectorAll('[data-upsell]:checked').forEach(function (u) {
        items.push({ id: parseInt(u.value, 10), quantity: 1 });
      });
      if (atc) { atc.classList.add('is-loading'); atc.disabled = true; }

      var protection = root.querySelector('[data-protection]:checked');
      var ready = protection
        ? fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var pid = parseInt(protection.value, 10);
              var already = cart.items.some(function (i) { return i.variant_id === pid; });
              if (!already) items.push({ id: pid, quantity: 1 });
            })
            .catch(function () { items.push({ id: parseInt(protection.value, 10), quantity: 1 }); })
        : Promise.resolve();

      ready.then(function () { return Cart.add(items); })
        .then(function () {
          if (theme.skipToCheckout) { window.location.href = '/checkout'; return; }
          if (Cart.drawer() && theme.cartType === 'drawer') {
            Cart.open();
          } else {
            window.location.href = routes.cart;
          }
        })
        .catch(function (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
          else toast(err.message);
        })
        .finally(function () {
          if (atc) { atc.classList.remove('is-loading'); atc.disabled = !currentVariant.available; }
        });
    }
    if (form) form.addEventListener('submit', submit);

    /* --- sticky ATC --- */
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }).observe(atc);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Gallery                                                             */
  /* ------------------------------------------------------------------ */
  function initGallery(g) {
    var track = g.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-dot]'));

    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function goToIndex(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    g._goTo = function (mediaId) {
      var i = slides.findIndex(function (s) { return s.dataset.mediaId === mediaId; });
      if (i >= 0) goToIndex(i);
    };
    function setActive() {
      var i = index();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      var active = thumbs[i];
      if (active && active.parentElement) {
        var p = active.parentElement;
        var left = active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
      slides.forEach(function (s, n) {
        if (n !== i) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(setActive);
    }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { goToIndex(n); }); });
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goToIndex(index() - 1); });
    if (next) next.addEventListener('click', function () { goToIndex(index() + 1); });

    // jump to initially selected variant image without animation
    var activeThumb = g.querySelector('[data-thumb].is-active');
    if (activeThumb) {
      var i0 = thumbs.indexOf(activeThumb);
      if (i0 > 0) requestAnimationFrame(function () { track.style.scrollBehavior = 'auto'; track.scrollLeft = i0 * track.clientWidth; track.style.scrollBehavior = ''; });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Countdown & delivery dates                                          */
  /* ------------------------------------------------------------------ */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(el) {
    var out = el.querySelector('[data-countdown-text]');
    var tpl = el.dataset.template || '[time]';
    var endDate = (el.dataset.endDate || '').trim();
    var cutoff = parseInt(el.dataset.cutoffHour, 10);
    if (isNaN(cutoff)) cutoff = 16;

    function target() {
      var now = new Date();
      if (/^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
        var p = endDate.split('-');
        return new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59);
      }
      var t = new Date(now);
      t.setHours(cutoff, 0, 0, 0);
      if (t <= now) t.setDate(t.getDate() + 1);
      return t;
    }
    function tick() {
      var diff = Math.max(0, target() - new Date());
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var str = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      out.innerHTML = tpl.replace('[time]', '<strong>' + str + '</strong>');
      if (diff === 0 && /^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
        if (el.dataset.afterText) { out.textContent = el.dataset.afterText; el.classList.add('is-over'); }
        else el.hidden = true;
        clearInterval(timer);
        return;
      }
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  function initDelivery(el) {
    var skip = el.dataset.skipWeekends === 'true';
    var locale = document.documentElement.lang || undefined;
    function addDays(date, n) {
      var d = new Date(date);
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) n--;
      }
      return d;
    }
    function fmt(d) {
      try { return d.toLocaleDateString(locale, { month: 'short', day: 'numeric' }); }
      catch (e) { return d.toDateString().slice(4, 10); }
    }
    var today = new Date();
    var ship = addDays(today, parseInt(el.dataset.ship, 10) || 0);
    var min = addDays(today, parseInt(el.dataset.min, 10) || 0);
    var max = addDays(today, parseInt(el.dataset.max, 10) || 0);
    var a = el.querySelector('[data-delivery-date="0"]');
    var b = el.querySelector('[data-delivery-date="ship"]');
    var c = el.querySelector('[data-delivery-date="deliver"]');
    if (a) a.textContent = fmt(today);
    if (b) b.textContent = fmt(ship);
    if (c) c.textContent = fmt(min) + (max > min ? ' – ' + fmt(max) : '');
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-product-info]').forEach(initProduct);
    scope.querySelectorAll('[data-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-delivery]').forEach(initDelivery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
